/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const footerLinkStyle = {
  link: {
    // Only target non touch devices
    '@media (hover: hover) and (pointer: fine)': {
      '&:hover': {
        textDecoration: "underline",
        textUnderlineOffset: "0.25rem"
      },
    },
  }
}
